// extracted by mini-css-extract-plugin
module.exports = {"copied_container":"Copy_copied_container__4AAv_","copied":"Copy_copied__7cg3Y","button_copy_container":"Copy_button_copy_container__vw5BK"};